import React from 'react';
import { theme } from 'antd';

interface GovardMultiPaneProps {
  dossierPane: React.ReactNode;
  hubPane: React.ReactNode;
  sidecarPane?: React.ReactNode;
  isEdgeToEdge?: boolean;
}

/**
 * GovardMultiPane implements the 3-pane IDE-like workspace layout.
 * Enforces strict AntD tokens for background and spacing.
 */
export function GovardMultiPane({
  dossierPane,
  hubPane,
  sidecarPane,
  isEdgeToEdge = true,
}: GovardMultiPaneProps) {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        width: '100%',
        gap: token.marginMD, // 16px
        padding: isEdgeToEdge ? 0 : token.paddingLG,
        background: token.colorBgLayout, // #f9f7f4
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      {/* Left Pane: Dossier */}
      <aside
        style={{
          width: '320px',
          flexShrink: 0,
          background: token.colorBgContainer, // #fffdfa
          borderRadius: token.borderRadiusLG, // 16px
          border: `1px solid ${token.colorBorderSecondary}`,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {dossierPane}
      </aside>

      {/* Center Pane: Hub */}
      <main
        style={{
          flex: '1 1 0',
          minWidth: 0,
          background: token.colorBgContainer,
          borderRadius: token.borderRadiusLG,
          border: `1px solid ${token.colorBorderSecondary}`,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {hubPane}
      </main>

      {/* Right Pane: Sidecar (Optional) */}
      {sidecarPane && (
        <aside
          style={{
            width: '300px',
            flexShrink: 0,
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            border: `1px solid ${token.colorBorderSecondary}`,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
          }}
        >
          {sidecarPane}
        </aside>
      )}
    </div>
  );
}
